import BaseSwitcher from '@r1-frontend/ui-react/components/controls/baseSwitcher';
import Select from '@r1-frontend/ui-react/components/select/select';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ContactList } from '~/src/components/ContactList';
import { prepareMapOptions, YandexMap } from '~/src/components/YandexMap';
import NoSSR from '~/src/helpers/noSSR';
import { selectCompanyName } from '~/src/store/selectors/city';

import * as ST from './styled';

class Contact extends Component {
    static propTypes = {
        contacts: PropTypes.array,
    };

    static defaultProps = {
        contacts: [],
    };

    mapInstance = React.createRef();
    mapWrapRef = React.createRef();
    mapPoints = prepareMapOptions(this.props.contacts);
    selectOptions = this.prepareSelectOptions(this.props.contacts);

    state = {
        isOnlyDomru: false,
        selectedContact: null,
        displayedMapPoints: this.mapPoints,
        currentSelectOptions: this.selectOptions,
    }

    onSelectContact = (elem) => {
        this.setState({
            selectedContact: elem,
            displayedMapPoints: this.filterSelectedPoints(this.mapPoints, elem),
        });
    }

    onSwitchDomRuFilter = () => {
        this.setState(state => ({
            isOnlyDomru: !state.isOnlyDomru,
            selectedContact: null,
            displayedMapPoints: this.filterOnlyDomRu(this.mapPoints, !state.isOnlyDomru),
            currentSelectOptions: this.filterOnlyDomRu(this.selectOptions, !state.isOnlyDomru),
        }));
    }

    onClickContact = (id) => {
        const mapWrap = this.mapWrapRef?.current;
        const mapInstance = this.mapInstance?.current;
        if (mapWrap && mapInstance) {
            mapInstance.openMapBalloon(id);
            mapWrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }

    prepareSelectOptions(contacts) {
        return contacts.map(item => {
            const { pid, address, type } = item;
            return (
                {
                    value: pid,
                    label: address,
                    contactType: type,
                }
            );
        });
    }

    filterOnlyDomRu(list, isOnlyDomru) {
        return isOnlyDomru ? list.filter(elem => (elem.contactType === 'center' || elem.contactType === 'office')) : list;
    }

    filterSelectedPoints(list, selectedContact) {
        const selectedPoints = selectedContact ? list.find(item => item.id === selectedContact.value) : undefined;
        return selectedPoints ? [selectedPoints] : list;
    }

    render() {
        const { selectedContact, isOnlyDomru, displayedMapPoints, currentSelectOptions } = this.state;
        const { city, companyName } = this.props;

        const title = city.domain === 'interzet' ? `Контакты в ${city.cityIn}` : 'Контакты';

        return (
            <ST.Content>
                <ST.InnerWrap>
                    <ST.Title>{title}</ST.Title>
                    <ST.FeedbackWrap>
                        <ST.FeedbackTitle>Оставьте заявку или обращение на сайте</ST.FeedbackTitle>
                        <ST.FeedbackLinksWrap>
                            <ST.BlockNoteLink href='/request'>Оставить заявку на подключение</ST.BlockNoteLink>
                            <ST.HeadPhoneLink href='/lk/feedback'>Оставить обращение</ST.HeadPhoneLink>
                        </ST.FeedbackLinksWrap>
                    </ST.FeedbackWrap>
                    <ST.FilterWrap>
                        <NoSSR>
                            <ST.SelectWrap>
                                <Select
                                    options={currentSelectOptions}
                                    value={selectedContact}
                                    isSearchable={true}
                                    isClearable={true}
                                    onChange={this.onSelectContact}
                                    placeholder='Поиск по адресам'
                                    noOptionsMessage={()=>'нет совпадений'}
                                    styles={ST.customStylesSelect}
                                />
                            </ST.SelectWrap>
                            <ST.SwitcherWrap>
                                <BaseSwitcher onChange={this.onSwitchDomRuFilter} checked={isOnlyDomru}>Только {companyName}</BaseSwitcher>
                            </ST.SwitcherWrap>
                        </NoSSR>
                    </ST.FilterWrap>
                </ST.InnerWrap>
                <ST.MapWrap ref={this.mapWrapRef}>
                    <NoSSR>
                        <YandexMap ref={this.mapInstance} points={displayedMapPoints} />
                    </NoSSR>
                </ST.MapWrap>
                <ST.InnerWrap>
                    <ST.ContactsWrap>
                        <ContactList contacts={displayedMapPoints} onClickContact={this.onClickContact}/>
                    </ST.ContactsWrap>
                </ST.InnerWrap>
            </ST.Content>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    companyName: selectCompanyName(state),
});

export default connect(mapStateToProps)(Contact);
